// Participant data for team randomization

// Product Engineering team members
export const PE_TEAM = ['Max', 'Erik', 'Tilo', 'Philipp'] as const;

// Customer Engineering team members
export const CE_TEAM = ['Quirin', 'Thomas', 'Daniel', 'Marius'] as const;

// Special participant
export const SEDI = 'SeDi' as const;
